module.exports = __webpack_public_path__ + "img/icon-check--green.6e4a2135.svg";